import * as React from 'react';

function SvgChartArrow(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 23.98 18.03" focusable={false} role="presentation" aria-hidden={true} {...props}>
      <path d="M23.99 16.48V18h-24V0h1.59v16.3h22.41zM22.58 1.91v5c0 .17 0 .35-.18.35s-.17 0-.35-.18l-1.4-1.38L13.3 13a.6.6 0 01-.35.17c-.17 0-.17 0-.35-.17l-2.8-2.78-4.9 4.86-2.27-2.25 6.82-6.76a.64.64 0 01.35-.17c.18 0 .18 0 .35.17l2.84 2.78 5.43-5.38-1.43-1.39c-.26-.17-.18-.34-.18-.34a.38.38 0 01.35-.18h5.08c.17 0 .35 0 .35.21z" />
    </svg>
  );
}

const MemoSvgChartArrow = React.memo(SvgChartArrow);
export default MemoSvgChartArrow;
